import { styled } from '@nextiva/next-ui-components';

const StyledContainer = styled('div')({
  alignItems: 'center',
  display: 'flex',
});

const StyledImg = styled('img')({
  height: 'auto',
  marginRight: '2rem',
  width: '5rem',
});

const StyledWalletImg = styled('img')({
  height: 'auto',
  width: '2rem',
});

const SimpleParagraph = styled('p')({
  margin: 0,
});

const StyledParagraph = styled('p')({
  alignItems: 'center',
  display: 'flex',
  gap: '0.625rem',
  verticalAlign: 'middle',
});

export {
  SimpleParagraph,
  StyledContainer,
  StyledImg,
  StyledParagraph,
  StyledWalletImg,
};
